// extracted by mini-css-extract-plugin
module.exports = {"date-column":"date-column___NT72H","flagged":"flagged___1-cb8","actions-column":"actions-column___2J4AY","dropdown-icon":"dropdown-icon___1Axv_"};